import { __assign } from "tslib";
import React from 'react';
import useClientMiddlewares from '../hooks/useClientMiddlewares';
var withClientMiddlewares = function (Component, options) {
    return function (pageProps) {
        var WithClientMiddlewaresComp = function () {
            var data = (useClientMiddlewares({ middlewares: options }) || {}).data;
            var parsedProps = __assign(__assign({}, pageProps), { data: data });
            return React.createElement(Component, __assign({}, parsedProps));
        };
        return WithClientMiddlewaresComp();
    };
};
export default withClientMiddlewares;
//# sourceMappingURL=withClientMiddlewares.js.map